import React from 'react';
import './Home.scss';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import RedditIcon from '@material-ui/icons/Reddit';
import { Link } from 'react-router-dom'
import Particles from 'react-particles-js';

function Home() {


    return (
        <div className="Home">
            <Particles
                className="particles"
                params={{
                    fpsLimit: 60,
                    interactivity: {
                        detectsOn: "canvas",
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.5,
                                size: 40,
                            },
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.2,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            direction: "none",
                            enable: true,
                            outMode: "bounce",
                            random: false,
                            speed: 2,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                value_area: 800,
                            },
                            value: 80,
                        },
                        opacity: {
                            value: 0.2,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            random: true,
                            value: 5,
                        },
                    },
                    detectRetina: true,
                }}
            />
            <div className="home-main">
                <div className="home-intro">
                    <div className="home-intro-info">
                        
                        <h1>Milan George</h1>
                        <h3>Game Developer</h3>
                        <div></div>
                        <button download="./projectpictures/MilanGeorge.pdf" onClick={() => {
                            window.open('./projectpictures/MilanGeorge.pdf', '_blank')
                        }}>Download CV</button>
                    </div>
                    <div className="home-intro-social">
                        <Link className="social-icon" onClick={()=>{
                            window.open('https://github.com/mln-grg', '_blank')
                        }}><GitHubIcon /></Link>
                        <Link  className="social-icon"  onClick={()=>{
                            window.open('https://in.linkedin.com/in/milan-george-0a41a4181', '_blank')
                        }}><LinkedInIcon /></Link>
                        <Link onClick={()=>{
                            window.open('https://twitter.com/sh4nks0', '_blank')
                        }} className="social-icon" ><TwitterIcon /></Link>
                        <Link onClick={()=>{
                            window.open('https://www.reddit.com/user/Sh4nks0', '_blank')
                        }} className="social-icon" ><RedditIcon /></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;
